import React from 'react';
import { HoInvitedBetterWayToBuildContainer } from '../../common';
import MobileSlider from './MobileSlider';
import DesktopSlider from './desktop-slider';

const BetterWayToBuild: React.FC = () => (
  <HoInvitedBetterWayToBuildContainer
    header="We’re simplifying the claims process."
    description="Your insurance company is using HOVER to make completing your
    claim easier. A little of your time and your phone is all you need."
    numberOfSlides={2}
    screenReaderText="Carousel with 2 slides shown at a time.Use the Previous and Next buttons
      to navigate, or the slide buttons at the start to jump to slides."
  >
    <MobileSlider />
    <DesktopSlider />
  </HoInvitedBetterWayToBuildContainer>
);

export default BetterWayToBuild;
